// extracted by mini-css-extract-plugin
module.exports = {"createTicket":"styles_createTicket__1V3P5"};